import {BaseComponentLocator} from './base.component-locator';
import {LevelGroupNames} from '../wa-services/wa-helper-service';


export class LevelLocatorComponent extends BaseComponentLocator {

  protected _id: number = null;
  protected _group: LevelGroupNames = null;
  protected _isGroup: boolean = false;

  public toString(): string {
    let str = 'L';
    if (this.isGroup) {
      str += this.group;
    }
    else {
      if (this.id === null) {
        str += 'None';
      }
      else {
        str += this.id;
      }
    }
    return str;
  }

  /**
   * Level id setter/getter.
   */
  public set id(levelId: number) {
    this._id = levelId;
    this._isGroup = false;
  }

  public get id(): number {
    return this._isGroup ? null : this._id;
  }

  public set group(groupLevel: LevelGroupNames) {
    this._group = groupLevel;
    this._isGroup = true;
  }

  public get group(): LevelGroupNames {
    return this._isGroup ? this._group : null;
  }

  public get isGroup(): boolean {
    return this._isGroup;
  }
}

